import React from "react";
import { useParams } from "react-router-dom";
import PaymentSuccessPage from "./PaymentSuccessPage";
import { useGetPaymentStatusQuery } from "@me-team/host/main/tariffPlans/graphql/tariffPlans.hooks";
import PaymentPendingPage from "./PaymentPendingPage";

const PaymentStatusPage: React.FC = () => {
    const { currentCompanyId, orderId } = useParams();

    const { data: dataPaymentStatus, refetch } = useGetPaymentStatusQuery({
        variables: {
            companyId: +currentCompanyId,
            orderId: +orderId,
        },
        skip: !currentCompanyId || !orderId,
        context: {
            errorType: "local",
        },
    });

    const order = dataPaymentStatus?.user?.company?.paymentOrders[0];
    const paymentInvoiceUrl = order?.invoiceUrl;

    return (
        <>
            {order?.status === "SUCCESS" ? (
                <PaymentSuccessPage paymentInvoiceUrl={paymentInvoiceUrl} />
            ) : (
                <PaymentPendingPage onRefetch={refetch} />
            )}
        </>
    );
};

export default PaymentStatusPage;
